import { render, staticRenderFns } from "./express-import.vue?vue&type=template&id=01538dcd&"
import script from "./express-import.vue?vue&type=script&lang=ts&"
export * from "./express-import.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports